module.exports = __webpack_public_path__ + "static/media/1.11d0fb35.jpg";